import { render } from "./UploadAssets.vue?vue&type=template&id=aca91b38&scoped=true"
import script from "./UploadAssets.vue?vue&type=script&lang=js"
export * from "./UploadAssets.vue?vue&type=script&lang=js"

import "./UploadAssets.vue?vue&type=style&index=0&id=aca91b38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca91b38"]])

export default __exports__